import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'

import {MainBodyContent} from '../../../components'
import { ProcurementContainer } from '../styled'

const VendorApplication = (props) => {
  return (
    <MainBodyContent headerTitle='Vendor Application'>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {},
    componentWillReceiveProps(nextProp) { }
  })
)

export default enhance(VendorApplication)
